import React, { FC, createContext, useState, useEffect } from 'react';
import { withRouter, RouteComponentProps } from 'react-router';

const RefetcherContext = createContext<IRefetcher>({
  refetchId: null,
  schedule: (id: string) => undefined,
  reset: () => undefined,
});

export interface IRefetcher {
  refetchId: string;
  schedule: (id: string) => void;
  reset: () => void;
}

const Provider: FC<RouteComponentProps> = ({ children, history, location }) => {
  const [refetchId, setRefetchId] = useState(null);

  useEffect(() => {
    const unlisten = history.listen(nextLocation => {
      const isNavigating = nextLocation.pathname !== location.pathname;
      if (isNavigating) {
        onReset();
      }
    });
    return () => unlisten();
  });

  function onSet(id: string) {
    if (!id) {
      return onReset();
    }

    setRefetchId(id);
  }

  function onReset() {
    setRefetchId(null);
  }

  const value: IRefetcher = {
    refetchId,
    schedule: (id: string) => onSet(id),
    reset: () => onReset(),
  };

  return <RefetcherContext.Provider value={value}>{children}</RefetcherContext.Provider>;
};

const RefetcherConsumer = RefetcherContext.Consumer;
const RefetcherProvider = withRouter(Provider);

export { RefetcherContext, RefetcherProvider, RefetcherConsumer };
